import { SearchOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { type FilterConfirmProps } from 'antd/es/table/interface';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ButtonHalfSpace = styled(Button)`
  width: 90px;
`;

export interface ITableColumnFilterButtonsProps {
  clearFilters: (() => void) | undefined;
  confirm: (param?: FilterConfirmProps | undefined) => void;
  /**
   * Disabilita il pulsante di conferma.
   */
  isInvalid?: boolean | undefined;
}

/**
 * Centralizzazione dei pulsanti per i filtri delle colonne delle tabelle. (conferma e reset)
 */
export function TableColumnFilterButtons(
  props: ITableColumnFilterButtonsProps,
) {
  const { clearFilters, confirm, isInvalid } = props;
  const { t } = useTranslation();

  return (
    <Space size={8}>
      <ButtonHalfSpace
        onClick={() => {
          clearFilters?.();
          confirm({ closeDropdown: true });
        }}
        size="small"
      >
        {t('table.table-column-filter-buttons.reset', 'Reset')}
      </ButtonHalfSpace>
      <ButtonHalfSpace
        type="primary"
        onClick={() => {
          if (isInvalid) return;
          confirm({ closeDropdown: true });
        }}
        icon={<SearchOutlined />}
        size="small"
        disabled={isInvalid}
      >
        {t('table.table-column-filter-buttons.search', 'Cerca')}
      </ButtonHalfSpace>
    </Space>
  );
}
